import '../scss/style.scss';



document.addEventListener('DOMContentLoaded', function () {
    // Function to toggle sub-menu visibility
    function toggleSubMenu(event) {
        const target = event.target.closest('.menu-item-has-children');
        if (target) {
            const subMenu = target.querySelector('.sub-menu');
            if (subMenu) {
                const parent = target.parentElement;
                // Hide all other sub-menus and remove active classes
                parent.querySelectorAll('.menu-item-has-children').forEach(menuItem => {
                    const sub = menuItem.querySelector('.sub-menu');
                    menuItem.classList.remove('sub-menu--active');

                    if (sub && sub !== subMenu) {
                        sub.classList.remove('sub-menu--active');
                    }

                    // Remove 'active' class from first child link of other sub-menus
                    const firstChildLink = menuItem.querySelector('.sub-menu li.menu-item-has-children:first-child a');
                    if (firstChildLink) {
                        firstChildLink.classList.remove('sub-menu--active');
                    }
                });

                // Toggle the clicked sub-menu and menu item active class
                const isActive = subMenu.classList.contains('sub-menu--active');
                target.classList.toggle('sub-menu--active', !isActive);
                subMenu.classList.toggle('sub-menu--active', !isActive);

                // Add 'active' class to the first child link inside the opened sub-menu
                if (!isActive) {
                    const firstChildLink = subMenu.querySelector('li.menu-item-has-children:first-child a');
                    if (firstChildLink) {
                        firstChildLink.classList.add('sub-menu--active');
                    }
                }

                event.stopPropagation(); // Prevent propagation to parent menus
            }
        }
    }

    // Function to hide all sub-menus
    function hideAllSubMenus() {
        document.querySelectorAll('.menu-item-has-children').forEach(menuItem => {
            menuItem.classList.remove('active');
            const subMenu = menuItem.querySelector('.sub-menu');
            if (subMenu) {
                subMenu.classList.remove('active');
            }

            // Remove 'active' class from first child link
            const firstChildLink = menuItem.querySelector('.sub-menu li.menu-item-has-children:first-child a');
            if (firstChildLink) {
                firstChildLink.classList.remove('active');
            }
        });
    }

    // Initially hide all sub-menus
    document.querySelectorAll('.menu-item-has-children > .sub-menu').forEach(subMenu => {
        subMenu.classList.remove('active'); // Remove active class initially
    });

    // Attach click event listener to all menu items with children
    document.querySelectorAll('.menu-item-has-children').forEach(menuItem => {
        menuItem.addEventListener('click', toggleSubMenu);
    });

    // Hide sub-menus when clicking outside
    document.addEventListener('click', function (event) {
        if (!event.target.closest('#primary-menu')) {
            hideAllSubMenus();
        }
    });
});


(function () {
    const hamburgerToggler = () => {
        let DOM = {};

        function activeMobileNav(e) {
            e.preventDefault();
            DOM.mobile_navigation.classList.toggle('mobile-nav--active');
        }

        function hideMobileNav(e) {
            e.preventDefault();
            DOM.mobile_navigation.classList.remove('mobile-nav--active');
        }

        function eventListeners() {
            DOM.hamburger.addEventListener('click', activeMobileNav);
            DOM.btn_close.addEventListener('click', hideMobileNav);
        }

        function cacheDOM() {
            DOM.hamburger = document.querySelector('.toggle-btn');
            DOM.btn_close = document.querySelector('.btn-close');
            DOM.mobile_navigation = document.getElementById('mobileNav');
        }

        function init() {
            cacheDOM();
            eventListeners();
        }

        return {
            init,
        };
    }
    const readmoreToggler = () => {
        const MODULE = {};

        function init() {
            const wrappers = document.querySelectorAll('.readmore-wrapper');

            wrappers.forEach(wrapper => setupInstance(wrapper));
        }

        function setupInstance(wrapper) {
            let DOM = {};
            let fullText = '';

            // per-instance char limit with fallback
            const CHAR_LIMIT = parseInt(wrapper.dataset.limit) || 700;

            // cache DOM
            DOM.content = wrapper.querySelector('.about-page-top__right-content');
            DOM.button = wrapper.querySelector('.readmore-btn');

            if (!DOM.content || !DOM.button) return;

            fullText = DOM.content.textContent.trim();

            // short text → no readmore
            if (fullText.length <= CHAR_LIMIT) {
                DOM.button.style.display = "none";
                return;
            }

            // initial trimmed text
            DOM.content.textContent = fullText.substring(0, CHAR_LIMIT) + "...";

            // bind toggle
            DOM.button.addEventListener("click", function (e) {
                e.preventDefault();

                const expanded = DOM.content.classList.toggle("is-expanded");

                if (expanded) {
                    DOM.content.textContent = fullText;
                    DOM.button.textContent = "Show Less";
                } else {
                    DOM.content.textContent = fullText.substring(0, CHAR_LIMIT) + "...";
                    DOM.button.textContent = "Read More";
                }
            });
        }

        MODULE.init = init;
        return MODULE;
    };

    const popupWithSlider = () => {
        let DOM = {};
        let currentIndex = 0;
        let images = [];

        // -------------------------
        // Cache DOM Elements
        // -------------------------
        function cacheDOM() {
            DOM.banner = document.querySelector(".single-trips-banner");
            if (!DOM.banner) return;

            images = Array.from(DOM.banner.querySelectorAll("img"));

            // ✅ Hide all except first 3
            images.forEach((img, index) => {
                if (index > 2) img.style.display = "none";
            });

            // ✅ Create popup structure
            const popup = document.createElement("div");
            popup.className = "image-popup";
            popup.innerHTML = `
                <div class="image-popup__inner">
                    <div class="popup-close">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.127 6.87301C17.2431 6.98909 17.3352 7.1269 17.3981 7.27858C17.4609 7.43026 17.4932 7.59283 17.4932 7.75701C17.4932 7.92119 17.4609 8.08376 17.3981 8.23544C17.3352 8.38712 17.2431 8.52493 17.127 8.64101L13.767 12L17.127 15.359C17.2431 15.4751 17.3352 15.6129 17.398 15.7646C17.4608 15.9163 17.4932 16.0788 17.4932 16.243C17.4932 16.4072 17.4608 16.5697 17.398 16.7214C17.3352 16.8731 17.2431 17.0109 17.127 17.127C17.0109 17.2431 16.8731 17.3352 16.7214 17.398C16.5697 17.4608 16.4072 17.4932 16.243 17.4932C16.0788 17.4932 15.9163 17.4608 15.7646 17.398C15.6129 17.3352 15.4751 17.2431 15.359 17.127L12 13.767L8.641 17.127C8.40655 17.3615 8.08857 17.4932 7.757 17.4932C7.42544 17.4932 7.10745 17.3615 6.873 17.127C6.63855 16.8926 6.50684 16.5746 6.50684 16.243C6.50684 15.9114 6.63855 15.5935 6.873 15.359L10.233 12L6.873 8.64101C6.63855 8.40656 6.50684 8.08857 6.50684 7.75701C6.50684 7.42544 6.63855 7.10746 6.873 6.87301C7.10745 6.63856 7.42544 6.50684 7.757 6.50684C8.08857 6.50684 8.40655 6.63856 8.641 6.87301L12 10.233L15.359 6.87301C15.4751 6.7569 15.6129 6.6648 15.7646 6.60196C15.9162 6.53912 16.0788 6.50677 16.243 6.50677C16.4072 6.50677 16.5698 6.53912 16.7214 6.60196C16.8731 6.6648 17.0109 6.7569 17.127 6.87301Z" fill="white"/>
                        </svg>
                    </div>
                    <button class="nav-arrow nav-prev" aria-label="Previous image">&#10094;</button>
                    <img src="" alt="popup image">
                    <button class="nav-arrow nav-next" aria-label="Next image">&#10095;</button>
                </div>
            `;
            document.body.appendChild(popup);

            // ✅ Cache popup elements
            DOM.popup = popup;
            DOM.popupImg = popup.querySelector("img");
            DOM.prevBtn = popup.querySelector(".nav-prev");
            DOM.nextBtn = popup.querySelector(".nav-next");
            DOM.closeBtn = popup.querySelector(".popup-close");
        }

        // -------------------------
        // Toggle Popup
        // -------------------------
        function popupToggler(show, index = 0) {
            if (show) {
                currentIndex = index;
                updatePopup();
                DOM.popup.classList.add("active");
                document.body.style.overflow = "hidden";
            } else {
                DOM.popup.classList.remove("active");
                document.body.style.overflow = "";
            }
        }

        // -------------------------
        // Update Image + Navigation
        // -------------------------
        function updatePopup() {
            DOM.popupImg.src = images[currentIndex].src;
            DOM.prevBtn.style.display = currentIndex === 0 ? "none" : "block";
            DOM.nextBtn.style.display = currentIndex === images.length - 1 ? "none" : "block";
        }

        // -------------------------
        // Event Listeners
        // -------------------------
        function eventListeners() {
            if (!DOM.banner) return;

            // Open popup on image click
            DOM.banner.addEventListener("click", (e) => {
                const target = e.target;
                if (target.tagName.toLowerCase() === "img") {
                    const index = images.indexOf(target);
                    popupToggler(true, index);
                }
            });

            // Close popup (button)
            DOM.closeBtn.addEventListener("click", (e) => {
                e.stopPropagation();
                popupToggler(false);
            });

            // Navigation
            DOM.prevBtn.addEventListener("click", (e) => {
                e.stopPropagation();
                if (currentIndex > 0) {
                    currentIndex--;
                    updatePopup();
                }
            });

            DOM.nextBtn.addEventListener("click", (e) => {
                e.stopPropagation();
                if (currentIndex < images.length - 1) {
                    currentIndex++;
                    updatePopup();
                }
            });

            // Close when clicking outside the image
            DOM.popup.addEventListener("click", (e) => {
                if (!e.target.closest("img") && !e.target.closest(".nav-arrow") && !e.target.closest(".popup-close")) {
                    popupToggler(false);
                }
            });

            // Keyboard controls
            document.addEventListener("keydown", (e) => {
                if (!DOM.popup.classList.contains("active")) return;

                if (e.key === "Escape") {
                    popupToggler(false);
                } else if (e.key === "ArrowRight" && currentIndex < images.length - 1) {
                    currentIndex++;
                    updatePopup();
                } else if (e.key === "ArrowLeft" && currentIndex > 0) {
                    currentIndex--;
                    updatePopup();
                }
            });
        }

        // -------------------------
        // Init
        // -------------------------
        function init() {
            cacheDOM();
            eventListeners();
        }

        // Public API
        return { init };
    };

    const customAccordion = () => {
        let DOM = {};

        function cacheDOM() {
            DOM.accordions = document.querySelectorAll('.accordion');
        }

        function accordionToggler(header, content, items, allowMultiple = false) {
            const isOpen = header.getAttribute('aria-expanded') === 'true';

            // If only one open at a time
            if (!allowMultiple) {
                items.forEach(item => {
                    const h = item.querySelector('.accordion__header');
                    const c = item.querySelector('.accordion__content');
                    h.setAttribute('aria-expanded', 'false');
                    c.style.maxHeight = null;
                    c.classList.remove('active');
                });
            }

            // Toggle selected
            if (!isOpen) {
                header.setAttribute('aria-expanded', 'true');

                console.log(content.scrollHeight)
                content.style.maxHeight = content.scrollHeight + 30 + 'px';
                content.classList.add('active');
            } else {
                header.setAttribute('aria-expanded', 'false');
                content.style.maxHeight = null;
                content.classList.remove('active');
            }
        }

        // New function to expand or collapse all
        function toggleAll(accordionEl, expand = true) {
            const items = accordionEl.querySelectorAll('.accordion__item');
            items.forEach(item => {
                const header = item.querySelector('.accordion__header');
                const content = item.querySelector('.accordion__content');

                if (expand) {
                    header.setAttribute('aria-expanded', 'true');
                    content.style.maxHeight = content.scrollHeight + 30 + 'px';
                    content.classList.add('active');
                } else {
                    header.setAttribute('aria-expanded', 'false');
                    content.style.maxHeight = null;
                    content.classList.remove('active');
                }
            });
        }

        function setupAccordion(accordionEl) {
            const items = accordionEl.querySelectorAll('.accordion__item');

            // Accordion item click
            items.forEach(item => {
                const header = item.querySelector('.accordion__header');
                const content = item.querySelector('.accordion__content');
                header.addEventListener('click', () =>
                    accordionToggler(header, content, items, true) // set to true for multi-open
                );
            });

            // Expand All toggle (within same accordion container)
            const switchCheckbox = accordionEl
                .closest('.accordion-outside')
                ?.querySelector('.custom-switch-checkbox');

            if (switchCheckbox) {
                switchCheckbox.addEventListener('change', (e) => {
                    const expand = e.target.checked;
                    toggleAll(accordionEl, expand);
                });
            }
        }

        function eventListeners() {
            if (!DOM.accordions.length) return;
            DOM.accordions.forEach(acc => setupAccordion(acc));
        }

        function init() {
            cacheDOM();
            eventListeners();
        }

        return {
            init,
        };
    };

    const customTripModal = () => {
        let DOM = {};

        // Cache DOM Elements
        function cacheDOM() {
            DOM.customizeBtn = document.getElementById("customizeTrip");
            DOM.customizeModal = document.getElementById("customizeTripModal");
            DOM.modals = document.querySelectorAll(".custom-modal");
        }

        // Open / Close Modals
        function openModal(modal) {
            if (!modal) return;
            modal.classList.add("active");
            document.body.style.overflow = "hidden";
        }

        function closeModal(modal) {
            if (!modal) return;
            modal.classList.remove("active");
            document.body.style.overflow = "";
        }

        // Event Listeners
        function eventListeners() {

            if (DOM.customizeBtn) {
                DOM.customizeBtn.addEventListener("click", (e) => {
                    e.preventDefault();
                    openModal(DOM.customizeModal);
                });
            }

            // Close when clicking overlay or close button
            DOM.modals.forEach((modal) => {
                modal.addEventListener("click", (e) => {
                    if (
                        e.target.classList.contains("custom-modal__overlay") ||
                        e.target.classList.contains("custom-modal__close")
                    ) {
                        closeModal(modal);
                    }
                });
            });

            // Close with ESC key
            document.addEventListener("keydown", (e) => {
                if (e.key === "Escape") {
                    DOM.modals.forEach((modal) => {
                        if (modal.classList.contains("active")) closeModal(modal);
                    });
                }
            });
        }
        function init() {
            cacheDOM();
            eventListeners();
        }

        return { init };
    };

    const stickyNavToggler = () => {
        let DOM = {};

        function cacheDOM() {
            DOM.stickyNav = document.querySelector('#stickyCustom');
            DOM.menu = document.querySelector('#stickyCustom ul');
            DOM.links = DOM.menu.querySelectorAll('a');
            DOM.sections = Array.from(DOM.links).map(link => {
                let section = document.querySelector(link.getAttribute('href'));
                return section ? { link, section } : null;
            }).filter(item => item !== null);
        }

        function setActiveLink(activeLink) {
            // Remove active class from all links and parent <li>
            DOM.links.forEach(link => {
                link.classList.remove('active');
                link.parentElement.classList.remove('active');
            });

            // Add active class to the clicked link and its parent <li>
            activeLink.classList.add('active');
            activeLink.parentElement.classList.add('active');
        }

        function getVisibleHeight(section) {
            const rect = section.getBoundingClientRect();
            const viewportHeight = window.innerHeight;

            // Calculate the visible height of the section
            const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
            return Math.max(visibleHeight, 0); // Ensure the height is not negative
        }

        function checkSections() {
            let scrollTop = window.scrollY;
            let firstSection = DOM.sections[0].section;
            let lastSection = DOM.sections[DOM.sections.length - 1].section;
            let firstSectionRect = firstSection.getBoundingClientRect();
            let lastSectionRect = lastSection.getBoundingClientRect();
            let sectionReachedTop = false;
            let mostVisibleLink = null;
            let maxVisibleHeight = 0;

            // Hide sticky nav if user is at the very top of the page
            if (scrollTop < firstSection.offsetTop) {
                DOM.stickyNav.classList.remove('visible');
                return;
            }

            // Hide sticky nav when last section is completely out of view
            if (lastSectionRect.bottom <= 0) {
                DOM.stickyNav.classList.remove('visible');
                return;
            }

            // Check which section has the maximum visible area
            DOM.sections.forEach(({ link, section }) => {
                const visibleHeight = getVisibleHeight(section);

                if (visibleHeight > maxVisibleHeight) {
                    maxVisibleHeight = visibleHeight;
                    mostVisibleLink = link;
                }

                // Check if any section has reached the top of the viewport
                const rect = section.getBoundingClientRect();
                if (rect.top <= 10 && rect.bottom > 10) {
                    sectionReachedTop = true;
                }
            });

            // Show sticky nav if a section has reached the top
            if (sectionReachedTop) {
                DOM.stickyNav.classList.add('visible');
            }

            if (mostVisibleLink) {
                setActiveLink(mostVisibleLink);
            }
        }

        function onLinkClick(event) {
            let clickedLink = event.currentTarget;
            setActiveLink(clickedLink);
        }

        function eventListeners() {
            window.addEventListener('scroll', () => {
                requestAnimationFrame(checkSections);
            });

            // Add click event listener to all navigation links
            DOM.links.forEach(link => {
                link.addEventListener('click', onLinkClick);
            });
        }

        function init() {
            cacheDOM();
            eventListeners();
            checkSections(); // Run once on page load
        }

        return {
            init,
        };
    };

    // Initialize when DOM is ready
    document.addEventListener("DOMContentLoaded", function () {
        hamburgerToggler().init();
        readmoreToggler().init();
        popupWithSlider().init();
        customAccordion().init();
        customTripModal().init();
        stickyNavToggler().init();
    });
})();




(function($) {

    const activitiesSlider = {
        init: function() {
            if (typeof $.fn.slick !== 'undefined') {
                $('.activities__wrapper').slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    autoplay: true,
                    margin: 32,
                    autoplaySpeed: 3000,
                    draggable: true,
                    swipe: true,
                    infinite: true,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: { slidesToShow: 3 }
                        },
                        {
                            breakpoint: 768,
                            settings: { slidesToShow: 2 }
                        },
                        {
                            breakpoint: 575,
                            settings: { slidesToShow: 1 }
                        }
                    ]
                });
            } else {
                console.error("Slick Slider library is not loaded.");
            }
        }
    };

    // Initialize sliders when the DOM is fully loaded
    $(document).ready(function() {
        activitiesSlider.init();
    });

})(jQuery);


























(function() {
    const stickyNavToggler = () => {
        let DOM = {};

        function cacheDOM() {
            DOM.stickyNav = document.querySelector('#stickyCustom');
            if (DOM.stickyNav) {
                // Only proceed if #stickyCustom exists
                DOM.menu = DOM.stickyNav.querySelector('ul');
                if (DOM.menu) {
                    DOM.links = DOM.menu.querySelectorAll('a');
                    // Ensure links exist before proceeding
                    if (DOM.links.length > 0) {
                        DOM.sections = Array.from(DOM.links).map(link => {
                            let section = document.querySelector(link.getAttribute('href'));
                            return section ? { link, section } : null;
                        }).filter(item => item !== null);
                    } else {
                        console.warn('No links found inside the menu');
                        DOM.sections = []; // Initialize DOM.sections as empty array
                    }
                } else {
                    console.warn('No <ul> found inside #stickyCustom');
                    DOM.sections = []; // Initialize DOM.sections as empty array
                }
            } else {
                console.warn('#stickyCustom not found');
                DOM.sections = []; // Initialize DOM.sections as empty array
            }
        }

        function setActiveLink(activeLink) {
            // Ensure that links exist before removing the active class
            if (DOM.links && DOM.links.length > 0) {
                // Remove active class from all links and parent <li>
                DOM.links.forEach(link => {
                    link.classList.remove('active');
                    link.parentElement.classList.remove('active');
                });

                // Add active class to the clicked link and its parent <li>
                activeLink.classList.add('active');
                activeLink.parentElement.classList.add('active');
            }
        }

        function getVisibleHeight(section) {
            const rect = section.getBoundingClientRect();
            const viewportHeight = window.innerHeight;

            // Calculate the visible height of the section
            const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
            return Math.max(visibleHeight, 0); // Ensure the height is not negative
        }

        function checkSections() {
            if (!DOM.sections || DOM.sections.length === 0) return; // Early return if no sections are defined

            let scrollTop = window.scrollY;
            let firstSection = DOM.sections[0].section;
            let lastSection = DOM.sections[DOM.sections.length - 1].section;
            let firstSectionRect = firstSection.getBoundingClientRect();
            let lastSectionRect = lastSection.getBoundingClientRect();
            let sectionReachedTop = false;
            let mostVisibleLink = null;
            let maxVisibleHeight = 0;

            // Hide sticky nav if user is at the very top of the page
            if (scrollTop < firstSection.offsetTop) {
                DOM.stickyNav.classList.remove('visible');
                return;
            }

            // Hide sticky nav when last section is completely out of view
            if (lastSectionRect.bottom <= 0) {
                DOM.stickyNav.classList.remove('visible');
                return;
            }

            // Check which section has the maximum visible area
            DOM.sections.forEach(({ link, section }) => {
                const visibleHeight = getVisibleHeight(section);

                if (visibleHeight > maxVisibleHeight) {
                    maxVisibleHeight = visibleHeight;
                    mostVisibleLink = link;
                }

                // Check if any section has reached the top of the viewport
                const rect = section.getBoundingClientRect();
                if (rect.top <= 10 && rect.bottom > 10) {
                    sectionReachedTop = true;
                }
            });

            // Show sticky nav if a section has reached the top
            if (sectionReachedTop) {
                DOM.stickyNav.classList.add('visible');
            }

            if (mostVisibleLink) {
                setActiveLink(mostVisibleLink);
            }
        }

        function onLinkClick(event) {
            let clickedLink = event.currentTarget;
            setActiveLink(clickedLink);
        }

        function eventListeners() {
            if (DOM.links && DOM.links.length > 0) {
                window.addEventListener('scroll', () => {
                    requestAnimationFrame(checkSections);
                });

                // Add click event listener to all navigation links
                DOM.links.forEach(link => {
                    link.addEventListener('click', onLinkClick);
                });
            }
        }

        function init() {
            cacheDOM();
            eventListeners();
            checkSections(); // Run once on page load
        }

        return {
            init,
        };
    };

    const itineraryExpandAll = () => {
        const DOM = {
            expandAllButton: document.querySelector('.itinerary-expand-all'),
            accordionItems: document.querySelectorAll('#tourItineraryAccordion .accordion-collapse'),
            accordionButtons: document.querySelectorAll('#tourItineraryAccordion .accordion-button')
        };

        let isExpanded = false;

        // Function to expand or collapse all accordions
        const toggleAll = () => {
            isExpanded = !isExpanded;
            DOM.accordionItems.forEach((item, index) => {
                if (isExpanded) {
                    item.classList.add('show');
                    item.setAttribute('aria-expanded', 'true');
                    DOM.accordionButtons[index].classList.remove('collapsed');
                } else {
                    item.classList.remove('show');
                    item.setAttribute('aria-expanded', 'false');
                    DOM.accordionButtons[index].classList.add('collapsed');
                }
            });
            DOM.expandAllButton.textContent = isExpanded ? 'Collapse All' : 'Expand All';
        };

        // Event handler for Expand All button
        const handleExpandButtonClick = (e) => {
            e.preventDefault();
            toggleAll();
        };

        // Initialize event listener
        const init = () => {
            if (DOM.expandAllButton) {
                DOM.expandAllButton.addEventListener('click', handleExpandButtonClick);
            }
        };

        return { init };
    };
    const faqExpandAll = () => {
        const DOM = {
            expandAllButton: document.querySelector('.faq-acc-expand-al'),
            accordionItems: document.querySelectorAll('#faq-acc .accordion-collapse'),
            accordionButtons: document.querySelectorAll('#faq-acc .accordion-button')
        };

        let isExpanded = false;

        // Function to expand or collapse all accordions
        const toggleAll = () => {
            isExpanded = !isExpanded;
            DOM.accordionItems.forEach((item, index) => {
                if (isExpanded) {
                    item.classList.add('show');
                    item.setAttribute('aria-expanded', 'true');
                    DOM.accordionButtons[index].classList.remove('collapsed');
                } else {
                    item.classList.remove('show');
                    item.setAttribute('aria-expanded', 'false');
                    DOM.accordionButtons[index].classList.add('collapsed');
                }
            });
            DOM.expandAllButton.textContent = isExpanded ? 'Collapse All' : 'Expand All';
        };

        // Event handler for Expand All button
        const handleExpandButtonClick = (e) => {
            e.preventDefault();
            toggleAll();
        };

        // Initialize event listener
        const init = () => {
            if (DOM.expandAllButton) {
                DOM.expandAllButton.addEventListener('click', handleExpandButtonClick);
            }
        };

        return { init };
    };
    const reviewFormExpander = () => {
        let DOM = {};

        function formToggler() {
            if (DOM.reviewForm && DOM.reviewForm.classList.contains('show')) {
                DOM.reviewForm.classList.remove('show');
            } else if (DOM.reviewForm) {
                DOM.reviewForm.classList.add('show');
            }
        }

        function eventListeners() {
            if (DOM.reviewBtn) {
                DOM.reviewBtn.addEventListener('click', formToggler);
            } else {
                console.warn('.reviewbtn not found in the DOM');
            }
        }

        function cacheDOM() {
            DOM.reviewBtn = document.querySelector('.reviewbtn');
            DOM.reviewForm = document.getElementById('review-form-panel');
        }

        function init() {
            cacheDOM();
            eventListeners();
        }

        return {
            init,
        };
    };
    const hamburgerToggler = () => {
        let DOM = {};

        function activeMobileNav(e) {
            e.preventDefault();
            DOM.mobile_navigation.classList.toggle('mobile-nav--active');
        }

        function hideMobileNav(e) {
            e.preventDefault();
            DOM.mobile_navigation.classList.remove('mobile-nav--active');
        }

        function eventListeners() {
            DOM.hamburger.addEventListener('click', activeMobileNav);
            DOM.btn_close.addEventListener('click', hideMobileNav);
        }

        function cacheDOM() {
            DOM.hamburger = document.querySelector('.toggle-btn');
            DOM.btn_close = document.querySelector('.btn-close');
            DOM.mobile_navigation = document.getElementById('mobileNav');
        }

        function init() {
            cacheDOM();
            eventListeners();
        }

        return {
            init,
        };
    }
    const sidebarGroupPriceToggler = () => {
        let DOM = {};

        function eventListeners() {
            document.addEventListener('click', function (event) {
                if (event.target.matches('.see-group-price-toggler')) {
                    classToggler(event.target);
                }
            });
        }

        function classToggler(toggler) {
            let content = document.querySelector('.single-sidebar-group-price__content');
            if (content) {
                content.classList.toggle('expanded');
                toggler.classList.toggle('active');
            }
        }


        function cacheDOM() {
            DOM.toggler = document.querySelector('.see-group-price-toggler');
            DOM.content = document.querySelector('.single-sidebar-group-price__content');
        }

        function init() {
            cacheDOM();
            eventListeners();
        }

        return {
            init,
        };
    };

    // Initialize sliders when the DOM is fully loaded
    document.addEventListener("DOMContentLoaded", function () {
        // stickyNavToggler().init();
        // itineraryExpandAll().init();
        // faqExpandAll().init();
        // reviewFormExpander().init();
        // hamburgerToggler().init();
        // sidebarGroupPriceToggler().init();
    });
})();


(function($) {
    const bannerSlider = {
        init: function() {
            if (typeof $.fn.slick !== 'undefined') {
                $('.banner__slider').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    autoplay: true,
                    margin: 32,
                    autoplaySpeed: 3000,
                    draggable: true,
                    swipe: true,
                    infinite: true,
                });
            } else {
                console.error("Slick Slider library is not loaded.");
            }
        }
    };

    const activitiesSlider = {
        init: function() {
            if (typeof $.fn.slick !== 'undefined') {
                $('.activities-card__wrapper').slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    autoplay: true,
                    margin: 32,
                    autoplaySpeed: 3000,
                    draggable: true,
                    swipe: true,
                    infinite: true,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: { slidesToShow: 3 }
                        },
                        {
                            breakpoint: 768,
                            settings: { slidesToShow: 2 }
                        },
                        {
                            breakpoint: 575,
                            settings: { slidesToShow: 1 }
                        }
                    ]
                });
            } else {
                console.error("Slick Slider library is not loaded.");
            }
        }
    };

    // Initialize sliders when the DOM is fully loaded
    $(document).ready(function() {
        // bannerSlider.init();
        // activitiesSlider.init();
    });

})(jQuery);

// (function () {
//     // Scroll Top Starts
//     var mybutton = document.getElementById("scroll-top"); //Get the button
//     window.onscroll = function () {
//         scrollFunction();
//     };
//
//     function scrollFunction() {
//         if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
//             mybutton.style.display = "block";
//         } else {
//             mybutton.style.display = "none";
//         }
//     }
//
//     function topFunction() {
//         document.body.scrollTop = 0;
//         document.documentElement.scrollTop = 0;
//     }
//
//     // expose only this function
//     window.topFunction = topFunction;
//     // Scroll Top Ends
//
//     // Show When Scroll Starts
//     document.addEventListener('DOMContentLoaded', function () {
//         var stickyCustom = document.getElementById('stickyCustom');
//         window.addEventListener('scroll', function () {
//             if (window.scrollY > 100) {
//                 stickyCustom.style.display = 'block';
//             } else {
//                 stickyCustom.style.display = 'none';
//             }
//         });
//
//         document.querySelectorAll('.sticky-custom a[href^="#"]').forEach(anchor => {
//             anchor.addEventListener('click', function (e) {
//                 e.preventDefault();
//
//                 const targetId = this.getAttribute('href').substring(1);
//                 const targetElement = document.getElementById(targetId);
//
//                 if (targetElement) {
//                     const navHeight = document.querySelector('.sticky-custom').offsetHeight;
//                     const targetPosition = targetElement.offsetTop - navHeight;
//
//                     window.scrollTo({
//                         top: targetPosition,
//                         behavior: 'smooth'
//                     });
//                 }
//             });
//         });
//     });
//     // Show When Scroll Ends
// })();

